import styled, { keyframes } from 'styled-components';
import { darken } from 'polished';

export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  height: calc(100% - 107px);
  background: var(--white);
  overflow: auto;
  padding: 0 30px;

  h1 {
    color: var(--blueDark);
  }

  > div {
    display: flex;
    justify-content: center;

    input {
      width: 80%;
      border: 2px solid var(--yellowDark);
      border-radius: 2px 0 0 2px;
      border-right: 0;
      height: 35px;
      padding: 0 15px;
      margin: 10px 0 50px 0;
      color: var(--black);

      &::placeholder {
        color: var(--gray);
      }
    }

    > svg {
      border: 2px solid var(--yellowDark);
      padding-right: 3px;
      border-radius: 0 2px 2px 0;
      border-left: 0;
      height: 35px;
      margin: 10px 0 50px 0;
      cursor: pointer;
    }
  }
`;

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 40px;
  color: var(--greenDark);
  margin: 10px;
  font-size: 0.9rem;

  h3 {
    padding: 1px 0;
  }

  .status {
    display: flex;
    color: ${props => (props.statusColor ? props.statusColor : '#20303d')};
  }
`;

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  border: 1px solid rgba(207, 207, 207, 0.8);
  padding: 10px 20px;
  color: var(--greenDark);
  margin: 20px 40px;
  font-size: 0.8rem;

  .status {
    display: flex;
    padding: 10px 0;
    color: ${props => (props.statusColor ? props.statusColor : '#20303d')};
  }

  svg {
    color: var(--yellowDark);
    margin-right: 5px;
  }

  > div {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-size: 1rem;
    font-weight: bold;
  }
  div.myContract {
    display: flex;
    align-items: center;
    color: var(--blueDark);
    font-weight: bold;
    font-size: 1rem;
    padding: 5px;
    transition: all cubic - bezier(0.165, 0.84, 0.44, 1) 0.25s;

    &:hover {
      color: ${darken(0.2, '#1c2156')};
    }
  }

  h3 {
    padding: 1px 5px;
    font-size: 1.2rem;
    font-weight: bold;
    color: var(--blueDark);
  }

  button {
    display: flex;
    align-items: center;
    color: var(--blueDark);
    font-weight: bold;
    font-size: 1.1rem;
    padding: 5px;
    transition: all cubic - bezier(0.165, 0.84, 0.44, 1) 0.25s;

    &:hover {
      color: ${darken(0.2, '#1c2156')};
    }
  }
`;

const spin = keyframes`
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
`;

export const Loader = styled.div`
  border: 0.2em solid rgba(0, 0, 0, 0.1);
  border-top: 0.2em solid var(--grayDark);
  border-radius: 50%;
  width: 2.28571429rem;
  height: 2.28571429rem;
  animation: ${spin} 0.6s linear infinite;
  position: absolute;
  top: 50%;
  left: 50%;
  display: ${props => props.visible};
`;
